import axios from 'axios'
import { Capacitor } from '@capacitor/core'
import { capacitorHttpAdapter } from './capacitorHttpAdapter'

const isNative = Capacitor.isNativePlatform()

export const api = axios.create({
  baseURL: process.env.REACT_APP_CLOUD_FUNCTIONS_URL,
  adapter: isNative ? capacitorHttpAdapter : undefined
})

export const zApiMultiService = axios.create({
  baseURL: process.env.REACT_APP_Z_API,
  adapter: isNative ? capacitorHttpAdapter : undefined
})

export const officialApiMultiService = axios.create({
  baseURL: process.env.REACT_APP_OFFICIAL_API,
  headers: {
    'Client-Token':
      process.env.REACT_APP_OFFICIAL_API_KEY || 'bca38b24a804aa37d821d31af00f5598230122c5bbfc4c4ad5ed40e4258f04ca'
  },
  adapter: isNative ? capacitorHttpAdapter : undefined
})

export const devzappApi = axios.create({
  baseURL: process.env.REACT_APP_DEVZAPP_API,
  adapter: isNative ? capacitorHttpAdapter : undefined
})
